export const HOME_API_ERROR_RESPONSE = {
  data: {
    description: 'ERROR_DATA',
    id: 'ERROR',
    layout: {
      campaign: undefined,
      catalog: undefined,
      category: undefined,
      filter: undefined,
      gnb: undefined,
    },
  },
}
